import {
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
} from "@mui/material";
import { US_STATE_NAMES } from "config";
import * as labels from "config.labels";
import { useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import { useTranslator } from "store/hooks/staticDataHooks";
import * as programSelectors from "store/selectors/input/program/programSelectors";

const MetaTable = ({ data }) => {
  return (
    <TableContainer>
      <Table size={"small"}>
        <TableBody>
          {(data ?? []).map((x, index) => (
            <TableRow key={index}>
              <TableCell
                sx={{
                  width: "1%",
                  whiteSpace: "nowrap",
                  verticalAlign: "baseline",
                  fontWeight: "600",
                  border: "none",
                }}
              >
                {x.label}
              </TableCell>
              <TableCell
                sx={{
                  width: "100%",
                  border: "none",
                }}
              >
                {x.value ?? "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const RegulatoryExemptions = () => {
  const resolvedProgram = useSelector(programSelectors.selectResolvedProgram);
  const { data: config, isLoading } = staticDataService.useConfigQuery(
    "regulatory_exemptions"
  );

  const { newYorkFreeTradeZone, deregulated } = resolvedProgram ?? {};

  const nyftzActive = newYorkFreeTradeZone?.isActive ?? false;
  const nyftzRiskDescription =
    isLoading || !nyftzActive
      ? "-"
      : newYorkFreeTradeZone?.riskCode == null
      ? "-"
      : `${newYorkFreeTradeZone?.riskCode}: ${
          (config?.nyftzClassCodes ?? []).find(
            (x) => x.key === newYorkFreeTradeZone?.riskCode
          )?.label
        }`;
  const deregActive = deregulated?.isActive ?? false;
  const deregTypeDescription =
    isLoading || !deregActive
      ? "-"
      : (config?.deregulatedStatusTypes ?? []).find(
          (x) => x.key === deregulated?.type
        )?.label;
  const deregJurisdictionDescription =
    !deregActive || deregulated.jurisdiction == null
      ? "-"
      : `${US_STATE_NAMES[deregulated?.jurisdiction]} (${
          deregulated?.jurisdiction
        })`;

  const translateLabel = useTranslator("uiLabels");

  if (!nyftzActive && !deregActive) {
    return <></>;
  }

  const nyftzTableData = [
    {
      label: "Exemption Category",
      value: translateLabel(labels.NEW_YORK_FREE_TRADE_ZONE_LABEL, {
        default: "New York Free Trade Zone",
      }),
    },
    {
      label: translateLabel(labels.NEW_YORK_FREE_TRADE_ZONE_RISK_CODE, {
        default: "Risk Code",
      }),
      value: nyftzRiskDescription,
    },
    {
      label: translateLabel(labels.NEW_YORK_FREE_TRADE_ZONE_COMMENT, {
        default: "Comment",
      }),
      value: newYorkFreeTradeZone?.comment,
    },
  ];

  const deregTableData = [
    {
      label: "Exemption Category",
      value: translateLabel(labels.DEREGULATED_LABEL, {
        default: "Deregulated",
      }),
    },
    {
      label: translateLabel(labels.DEREGULATED_TYPE, {
        default: "Type",
      }),
      value: deregTypeDescription,
    },
    {
      label: translateLabel(labels.DEREGULATED_JURISDICTION, {
        default: "Jurisdiction",
      }),
      value: deregJurisdictionDescription,
    },
    {
      label: translateLabel(labels.DEREGULATED_COMMENT, {
        default: "Comment",
      }),
      value: deregulated?.comment,
    },
  ];

  return (
    <div className={"print-section"}>
      <span className={"print-label"}>{"Regulatory Exemptions"}</span>
      <Stack gap={2} marginTop={2}>
        {nyftzActive && <MetaTable data={nyftzTableData} />}
        {deregActive && <MetaTable data={deregTableData} />}
      </Stack>
    </div>
  );
};

export default RegulatoryExemptions;
